export const HOME_ROUTE = '/';
export const REGISTER_ROUTE = '/register';
export const EDIT_ROUTE = '/edition';
export const CHAT_ROUTE = '/chat';
export const GAME_ROUTE = '/game';
export const ONE_PLAYER = '/oneplayer';
export const TWO_PLAYERS = '/twoplayers';
export const LOBBY_ROUTE = '/lobby';
export const PAGENOTFOUND404 = '/pagenotfound';
export const HELP = '/help';
export const ACTIVATE_USER = '/activate/:token';
export const DONATION_ROUTE = '/donation';
export const RECOVERY_ROUTE = '/recovery';

export const LOGO = 'https://res.cloudinary.com/team5-top20/image/upload/v1650832778/WORD_COMBAT_LOGO_WHITE_t2syjh.png';
